module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "1. Beyond Injustice"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "d12e685"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hend_ISBN9780785229223_epub_c5_r1#d12e308",
      "id": "d12e686"
    }
  }, [_vm._v("1"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Beyond Injustice")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e692"
    }
  }, [_c('span', {
    staticClass: "dcap",
    attrs: {
      "id": "d12e693"
    }
  }, [_vm._v("T")]), _vm._v("hough the autumn day was unseasonably warm, even by South Carolina standards, Debbie Townsend moved like a weary traveler caught in a snowstorm. As she followed me (Dr. Henderson) to my office, her head was bowed and her shoulders hunched forward. Her arms crossed her chest, gripping her sides as if to prevent an already broken spirit from crumbling into pieces. With a stone-cold face and a lifeless voice, she began to share her story. As she did, it became apparent that Debbie was carrying on her shoulders the weight of injustice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e696"
    }
  }, [_vm._v("Ten years ago at the age of thirty-five, Debbie was in bed when she heard someone breaking in through her front door. She was living alone with her three young children after divorcing a man who had been physically and emotionally abusive. The decision to leave him had been difficult. She was pregnant with their fourth child and had no money. She and the kids had lived at a domestic violence shelter on the outskirts of Columbia for a few months until she found a job and was able to get a place of her own. Now, with a home in the suburbs, she thought she would finally get some relief from the abuses that had plagued her marriage, but she was wrong. Huddled beneath the covers, she saw the silhouette of her ex-husband appear in the doorway. He was intoxicated and enraged. After violently beating Debbie, he left her unconscious and bleeding on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e698"
    }
  }, [_vm._v("When Debbie finally regained consciousness and called 911, she was taken to the hospital, where the emergency room doctors told her she had miscarried her fourth child as a result of the attack. She was overwhelmed with grief. To add insult to injury, she discovered that her ex-husband negotiated his way out of jail time and, instead, got off with a few months on probation. Her physical wounds eventually healed, but her emotional wounds had festered, eating away at her soul.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e700"
    }
  }, [_vm._v("As she sat in my office ten years later, she began to open up about the pain:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e702"
    }
  }, [_vm._v("I can’t sleep, I can’t eat, and I keep having flashbacks, panic attacks, and blackouts. I’m so angry! Yet I also feel overwhelming guilt, like maybe there was something I could have done to prevent the attack. For years I’ve tried to smile and pretend that everything is all right, but I just can’t do it anymore. Normal, everyday activities take all my strength, and familiar sounds—like the opening of a door or a car pulling into the driveway—make me jumpy and suspicious. I avoid my bedroom and often sleep on the couch at night. I can’t work or take care of my kids. I don’t want to die, but if this is what life is going to be like from here on, I really don’t want to live either.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e704"
    }
  }, [_vm._v("Debbie is just one of thousands of people who have faced the injustice of physical, sexual, or emotional abuse. The symptoms she described are what psychiatrists call post-traumatic stress disorder (PTSD). Risk factors for "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PTSD")]), _vm._v(" are not entirely clear, but they generally include the length of time a person is exposed to a traumatic event, prior emotional or psychiatric conditions, and/or lack of support from family or friends. The greatest obstacle to overcoming "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PTSD")]), _vm._v(" is a sufferer’s perceived sense of injustice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e706"
    }
  }, [_vm._v("Any pain, whether physical or emotional, is harder to overcome if it is viewed as injustice. Studies have shown that perceived injustice (as in the case of a car accident or work-related injury) is a potential risk factor for problems recovering from musculoskeletal injuries. An individual’s perception of injustice is likely to affect the severity of physical pain, the frequency of thinking about the pain, and feelings of being helpless to overcome it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Hend_ISBN9780785229223_epub_c47_r1#d12e4624",
      "id": "d12e708",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1*")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e711"
    }
  }, [_vm._v("If this is true, then imagine how important it is to deal with the pain of injustice as we strive to overcome other types of pain. If we are unable to move past the pain of injustice (even if the injustice is real), then we will never find purpose beyond our losses, our failures, or our experiences with death, loneliness, rejection, and discipline. We must overcome the sense of the unfairness of our pain before we can move forward to see the meaning beyond it.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_0",
      "role": "doc-chapter",
      "title": "Who’s to Blame? No Comparison"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "d12e713"
    }
  }, [_c('b', [_vm._v("Who’s to Blame? No Comparison")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e717"
    }
  }, [_vm._v("We hear about corporate corruption, sexual abuse, and mistreatment of innocent children, and we rightly cry out for justice. But we also see friends who never smoked a day in their lives get lung cancer, couples who would make great parents unable to conceive children, and promising young athletes crippled by injuries that shatter their dreams. Are these injustices? If so, to whom do we attribute blame?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e719"
    }
  }, [_vm._v("It is easy to compare our lives to others’ and wrongly perceive injustice. Jesus told the parable of the generous employer and the hired hands to illustrate this fact (Matt. 20:1–16). The first group of employees came early in the day and agreed to work for a specified price. They were satisfied with this agreement until they found out the employer had also decided to pay latecomers the same amount for fewer hours of work. Outraged, one of the employees objected that equal payment for unequal work was unjust!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e721"
    }
  }, [_vm._v("The employer answered them, “I haven’t been unfair! Didn’t you agree to work all day for the usual wage? Take your money and go. I wanted to pay this last worker the same as you. Is it against the law for me to do what I want with my money? Should you be jealous because I am kind to others?” (vv. 13–15 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NLT")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e726"
    }
  }, [_vm._v("Comparing our circumstances to others’ and calling it injustice will not bring relief from pain. It only makes it worse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e728"
    }
  }, [_vm._v("Equal treatment does not automatically represent what is fair and just. For example, two teenagers with differing IQs do not need to be treated the same in order to be treated fairly. Equality would demand that parents spend the same amount of time helping each child with his or her homework, but that would not be fair, because the needs of the one are greater than the other. Likewise, if both teenagers work hard to get into college, but only the smarter of the two gets a full scholarship, the parents would be perfectly justified in spending more for tuition on the child who struggles academically. The provisions are based on need, and though they are not equal, they are most certainly just.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e730"
    }
  }, [_vm._v("Not only do we struggle to define injustice, but we also have a hard time determining what actions to take when rectifying the wrong. Letting the punishment fit the crime is a murky business at best. As imperfect beings we often deal out imperfect justice. Who knows how many people are in jail for crimes they did not commit? How many people have escaped just punishment because of a technicality? We try our best to be fair, but even the most righteous judges in our courts are susceptible to subtle influences, shifts in mood, misinformation, or lapses in judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e732"
    }
  }, [_vm._v("What about punishment? Is a quick death at the hands of an executioner a fair punishment for the torture and murder of a helpless child? Is a two-hundred-dollar speeding ticket as equal a deterrent for a billionaire as it is for a third-grade teacher? Can we ever find a punishment that will satisfy the pain of our own personal injustices?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e734"
    }
  }, [_vm._v("The more questions we ask, the more we realize how little we understand about justice. Yet as we wrestle with our frustrations with God and with others, the dawn will break, we will open our eyes, and we will realize that we have prevailed over the pain!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ea7dc2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hend_ISBN9780785229223_epub_c11_r1.vue
// module id = 87
// module chunks = 0